import type { CommissionSupplierView } from '@caterinx/shared-types';

import { api } from './api.js';

/**
 * Provisionen und Rechnungen im Lieferantenportal.
 *
 * **Kein `supplierId`-Parameter, nirgends.** Die Identität kommt aus dem Cognito-Token; ein
 * Parameter wäre ein zweiter Weg zur selben Frage — und der eine Tag, an dem jemand vergisst,
 * ihn gegen das Token zu prüfen, ist der Tag, an dem ein Betrieb die Umsätze seines
 * Mitbewerbers liest.
 *
 * Die Typen kommen aus `@caterinx/shared-types`. Kommt im Backend ein Feld dazu, bricht hier
 * der Build — statt dass die Oberfläche es stillschweigend nicht anzeigt.
 */

export interface CommissionListResponse {
  count: number;
  items: CommissionSupplierView[];
  /** Was gerade offen ist: gestellt und überfällig zusammen, brutto. */
  openGrossCents: number;
}

export async function fetchMyCommissions(): Promise<CommissionListResponse> {
  return (await api.get<CommissionListResponse>('/commissions')).data;
}

export interface InvoiceDownload {
  downloadUrl: string;
  invoiceNumber: string | null;
  expiresInSeconds: number;
}

/**
 * Holt eine **kurzlebige** vorsignierte URL auf das Rechnungs-PDF.
 *
 * Sie wird bewusst erst beim Klick geholt und nicht mit der Liste mitgeliefert: Eine
 * vorsignierte URL trägt keine Identität — wer sie hat, kommt an die Datei. Zwanzig URLs im
 * Speicher einer offenen Registerkarte sind zwanzig Zugänge zu Belegen mit Firmenanschrift,
 * USt-IdNr. und Bankverbindung. Eine URL, die fünf Minuten nach dem Klick verfällt, ist
 * genau ein Zugang.
 */
export async function fetchInvoiceDownload(commissionId: string): Promise<InvoiceDownload> {
  return (await api.get<InvoiceDownload>(`/commissions/${commissionId}/invoice`)).data;
}
